import { farmStore, syncQueue, idMapStore } from '../../offline/indexedDBService'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export async function syncFarms() {
	const keys = await syncQueue.keys()

	for (const key of keys) {
		const action = await syncQueue.getItem(key)
		if (!action?.type?.startsWith('FARM_')) continue

		try {
			// Mapear breeder si es temporal
			if (action.payload?.breeder?.length > 20) {
				const resolved = await idMapStore.getItem(action.payload.breeder)
				if (resolved) action.payload.breeder = resolved
			}

			// Mapear technicians[] si alguno es temporal
			if (Array.isArray(action.payload.technicians)) {
				const mapped = []
				for (const tid of action.payload.technicians) {
					if (tid?.length > 20) {
						const resolved = await idMapStore.getItem(tid)
						mapped.push(resolved || tid)
					} else {
						mapped.push(tid)
					}
				}
				action.payload.technicians = mapped
			}

			if (action.type === 'FARM_ADD_OFFLINE') {
				const { data, status } = await Axios.post('/api/farm/register', action.payload, {
					headers: { auth: localStorage.getItem('jwt') }
				})
				if (status === 200 && data?.farm?._id) {
					await idMapStore.setItem(key, data.farm._id)
					await syncQueue.removeItem(key)
					await farmStore.removeItem(key)
				}
			}

			if (action.type === 'FARM_EDIT_OFFLINE') {
				const { data, status } = await Axios.put(`/api/farm/edit/${key}`, action.payload, {
					headers: { auth: localStorage.getItem('jwt') }
				})
				if (status === 200 || status === 264) {
					await syncQueue.removeItem(key)
					await farmStore.removeItem(key)
				}
			}
		} catch (error) {
			console.warn('Error al sincronizar farm offline:', error)
		}
	}
}
